import { defineMessages } from 'react-intl';

export default defineMessages({
    validationRequaredList: {
        id: 'accountManagement.views.register.validation.validation required list',
        defaultMessage: 'The following fields are required to submit this form: &lt;ul&gt;{fieldsList}&lt;/ul&gt;',
    }
});